import _slicedToArray from "/builds/client-projects/fert-demolition-motos-website/application/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import React, { useEffect, useState } from 'react';
import { useLanguageCode } from './TranslationContext';
import { useGlue } from '../hooks';

var AxiosTranslationComponent = function AxiosTranslationComponent(_ref) {
  var children = _ref.children;

  var _useLanguageCode = useLanguageCode(),
      _useLanguageCode2 = _slicedToArray(_useLanguageCode, 1),
      languageCode = _useLanguageCode2[0];

  var glue = useGlue();

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      ready = _useState2[0],
      setReady = _useState2[1];

  useEffect(function () {
    var languageInterceptor = glue.api.interceptors.request.use(function (config) {
      if (glue.isFrontTranslationEnabled()) {
        config.params = Object.assign(Object.assign({}, config.params), {
          lang: languageCode
        });
      }

      return config;
    });
    setReady(true);
    return function () {
      glue.api.interceptors.request.eject(languageInterceptor);
      setReady(false);
    };
  }, [glue.api, glue.isFrontTranslationEnabled, languageCode, setReady]);
  if (ready) return React.createElement(React.Fragment, null, children);else return null;
};

export var AxiosTranslationProvider = function AxiosTranslationProvider(_ref2) {
  var children = _ref2.children;

  var _useLanguageCode3 = useLanguageCode(),
      _useLanguageCode4 = _slicedToArray(_useLanguageCode3, 1),
      languageCode = _useLanguageCode4[0];

  if (languageCode) return React.createElement(AxiosTranslationComponent, {
    key: languageCode
  }, children);else return null;
};